import { Link } from 'react-router-dom';
import { Phone, MessageCircle, MapPin, Mail } from 'lucide-react';
import { CONTACT } from '../lib/data';

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-primary text-primary-foreground noise">
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <span className="font-display text-2xl font-semibold">
              Shiva Prints<span className="text-accent"> &amp; Packs</span>
            </span>
            <p className="mt-5 max-w-md text-primary-foreground/70 leading-relaxed">
              Delhi-based printing, packaging and corporate branding solutions.
              One trusted partner for your complete requirements, delivered across India.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href={CONTACT.tel}
                data-testid="footer-call"
                className="inline-flex items-center gap-2 bg-white text-primary px-5 py-3 text-sm font-medium hover:bg-accent hover:text-white transition-colors duration-300"
              >
                <Phone className="h-4 w-4" /> Call Now
              </a>
              <a
                href={CONTACT.whatsapp}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-whatsapp"
                className="inline-flex items-center gap-2 border border-white/30 px-5 py-3 text-sm font-medium hover:bg-white/10 transition-colors duration-300"
              >
                <MessageCircle className="h-4 w-4" /> WhatsApp Us
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="overline">Navigate</p>
            <ul className="mt-5 space-y-3">
              {[['Home', '/'], ['About Us', '/about'], ['Services', '/services'], ['Contact', '/contact']].map(([l, to]) => (
                <li key={to}>
                  <Link to={to} className="text-primary-foreground/70 hover:text-accent transition-colors">{l}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="overline">Get in touch</p>
            <ul className="mt-5 space-y-4 text-primary-foreground/80">
              <li className="flex items-center gap-3">
                <Phone className="h-4 w-4 text-accent" /> {CONTACT.phoneDisplay}
              </li>
              <li className="flex items-center gap-3">
                <MessageCircle className="h-4 w-4 text-accent" /> WhatsApp enquiries welcome
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 text-accent" />
                <a href={CONTACT.mailto} className="hover:text-accent transition-colors">{CONTACT.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-accent mt-1" />
                <span>{CONTACT.location}<br /><span className="text-primary-foreground/60">{CONTACT.coverage}</span></span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-sm text-primary-foreground/50">
          <p>© {new Date().getFullYear()} Shiva Prints &amp; Packs. Printing &amp; packaging solutions in Delhi, serving Pan India.</p>
          <p>Custom packaging manufacturer • Corporate printing services</p>
        </div>
      </div>
    </footer>
  );
}
